import Service from "../../Services";

const About = {
  namespaced: true,
  state: {
    form: {
      branch_id: "",
      name_th: "",
      name_en: "",
      description_th: "",
      description_en: "",
      full_profile_th: "",
      full_profile_en: "",
      image_path: "",
      image_name: "",
      contact_email: "",
      contact_info: "",
      viewer: "",
      slug_url: "",
      is_publish: true,
      orders: "",
      download_zip: true,
      template: "",
      video_url: "",
      slide_images: []
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        branch_id: "",
        name_th: "",
        name_en: "",
        description_th: "",
        description_en: "",
        full_profile_th: "",
        full_profile_en: "",
        image_path: "",
        image_name: "",
        slide_images_show: "",
        contact_email: "",
        contact_info: "",
        viewer: "",
        slug_url: "",
        is_publish: true,
        orders: "",
        download_show: true,
        template: "",
        video_url: "",
        slide_images: []
      };
    },
    SET_SLIDE_IMAGE: (state, data) => {
      state.form.slide_images = [
        ...state.form.slide_images,
        {
          ...data
        }
      ];
    },
    REMOVE_SLIDE_IMAGE: (state, index) => {
      state.form.slide_images = state.form.slide_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getAbout({ commit }, {page,search,sort_order}) {
      return Service.AboutAPI.getAbout(page,search,sort_order);
    },
    // eslint-disable-next-line no-unused-vars
    showAbout({ commit }, id) {
      return Service.AboutAPI.showAbout(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveAbout({ commit }, { id, data }) {
      if (id) {
        return Service.AboutAPI.updateAbout(id, data);
      } else {
        return Service.AboutAPI.createAbout(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteAbout({ commit }, id) {
      return Service.AboutAPI.deleteAbout(id);
    },
    setFormAbout({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    insertSlideImage({ commit }, data) {
      commit("SET_SLIDE_IMAGE", data);
    },
    removeSlideImage({ commit }, index) {
      commit("REMOVE_SLIDE_IMAGE", index);
    }
  }
};
export default About;
